import axios from 'axios';
import apiClient from './apiClient';

/**
 * Fetches tenant info by hostname from the public API.
 *
 * @param {string} hostname - The hostname to look up.
 * @param {AbortSignal} [signal] - Optional AbortSignal forwarded to axios so
 *   the request can be cancelled when the calling effect is cleaned up.
 * @returns {Promise<{slug: string, name: string, themeConfig: string|null, logoUrl: string}|null>}
 *   Resolves with the tenant info object on a 200 response,
 *   or null on any 4xx (including 404 for unknown/inactive hostname) or on
 *   abort.  Rejects on 5xx or network errors so callers can handle
 *   infrastructure issues.
 */
const getTenantByHostname = async (hostname, signal) => {
  try {
    const response = await apiClient.get('/public/tenant/by-hostname', {
      params: { hostname },
      signal
    });
    return response.data;
  } catch (error) {
    // Cancelled request — return null so callers can ignore gracefully.
    if (axios.isCancel(error)) {
      return null;
    }
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      // 404 unknown hostname, 400 invalid format — treat as "not matched"
      return null;
    }
    // 5xx or network error — re-throw so caller can decide
    throw error;
  }
};

const publicTenantService = { getTenantByHostname };

export default publicTenantService;
